import { __rest } from 'tslib';
import { jsx, Fragment } from '@emotion/react/jsx-runtime';
import { useRef, useEffect } from 'react';
import '../../hooks/useDetectInputMethod.js';
import { useId } from '@reach/auto-id';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import { renderProp } from '../../utils/renderProp.js';
import { useMenuDropdownContext } from '../MenuContext/MenuProvider.js';

var useMenuItem = function (_a) {
    var _b = _a === void 0 ? {} : _a, onClick = _b.onClick, onKeyDown = _b.onKeyDown, id = _b.id, disabled = _b.disabled, selected = _b.selected;
    var _c = useMenuDropdownContext(), menuItemRefs = _c.menuItemRefs, menuId = _c.id, activeItemId = _c.activeItemId, setActiveItemId = _c.setActiveItemId, setIsOpen = _c.setIsOpen;
    var ref = useRef(null);
    var itemId = id ? id : "".concat(menuId, "-item--").concat(useId());
    var clickHandler = function (event) {
        onClick && onClick(event);
        event.stopPropagation();
        !event.defaultPrevented && setIsOpen(false);
    };
    var keyDownHandler = function (event) {
        var _a, _b;
        onKeyDown && onKeyDown(event);
        if (((_a = ref.current) === null || _a === void 0 ? void 0 : _a.tagName) === "A" && event.code === "Space") {
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.click();
        }
    };
    var mouseOverHandler = function () {
        var _a;
        if (!disabled)
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var mouseOutHandler = function () {
        var _a;
        if (!disabled)
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.blur();
    };
    var focusHandler = function () {
        setActiveItemId(itemId);
    };
    var blurHandler = function () {
        activeItemId === itemId && setActiveItemId(undefined);
    };
    useEffect(function () {
        var _a;
        if (((_a = menuItemRefs.current) === null || _a === void 0 ? void 0 : _a.indexOf(ref)) === -1)
            menuItemRefs.current.push(ref);
        return function () {
            var _a;
            (_a = menuItemRefs.current) === null || _a === void 0 ? void 0 : _a.splice(menuItemRefs.current.indexOf(ref), 1);
        };
    }, []);
    return {
        props: {
            id: itemId,
            ref: ref,
            type: "button",
            role: "menuItem",
            disabled: disabled,
            "data-selected": selected,
            onClick: clickHandler,
            onKeyDown: keyDownHandler,
            onMouseOver: mouseOverHandler,
            onMouseOut: mouseOutHandler,
            onFocus: focusHandler,
            onBlur: blurHandler,
        },
    };
};
var MenuItemRenderProp = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var returnVal = useMenuItem(props);
    return jsx(Fragment, { children: renderProp({ prop: children, context: returnVal }) });
};

export { MenuItemRenderProp, useMenuItem };
//# sourceMappingURL=useMenuItem.js.map
